.link { font-family: var(--font-mono); font-weight: 500; letter-spacing: 1px; color: var(--strava); text-decoration: underline; text-transform: uppercase; }
